import React, { useEffect, useMemo, useState } from 'react'
import Header from '../../components/dashboard/Header'
import { Badge, Box, Button, Divider, Popover, Tooltip, Typography } from '@mui/material'
import { t } from 'i18next'
import { useDispatch, useSelector } from 'react-redux'
import {
    openModal,
    resetAllParams,
    resetCheckedExam,
    resetFilters,
    runComparaison,
    setAllKeyLayouts,
    setCategories,
    setData,
    setDataItems,
    TComparaisonFilters,
    updateCheckExam
} from '../../store/reducers/comparaison.reducer'
import { RootState } from '../../store'
import { TExam, TKeyParamLayout } from '../../shared/types/exam.type'
import ComparaisonChips from '../../components/comparaison/ComparaisonChips'
import { Ttraining } from '../../shared/types/training.type'
import { useExam } from '../../hooks/useExam'
import { LoadingButton } from '@mui/lab'
import ComparaisonSection from '../../components/comparaison/ComparaisonSection'
import { TgroupKeyParam, getAllLayoutKeysFromData, groupKeyParamsByCategories } from '../../shared/utils/comparaison'
import { toast } from 'react-toastify'
import { TtrainingKeyParameter } from '../../shared/types/trainingKeyParameter.type'
import { CompareArrows, Download } from '@mui/icons-material'
import { TUser } from '../../shared/types/user.type'
import { isEmpty, isNull, isUndefined, toNumber } from 'lodash'
import Page from '../../components/layout/Helmet'
import { StaticDatePicker } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { useAuth } from '../../hooks/useAuth'
import { Icon } from '@iconify/react'
import { useTracks } from '../../hooks/useTracks'
import ComparaisonFilters from '../../components/comparaison/ComparaisonFilters'
import { transformFiltersToArray } from '../../transformer/ViewFiltersComparaison'
import toggleItemInArray from '../../shared/utils/arrays'
import { TkeyParamLayout } from '../../shared/types/computedKeyParam.type'
import { UseFileDownload } from '../../hooks/useFileDownload'
import utc from 'dayjs/plugin/utc';
import SplitButton from "../../components/exams/SplitButton";
import { useUserActivityLog } from '../../hooks/useUserActivityLog'

dayjs.extend(utc)


function Comparaison() {
    const dispatch = useDispatch()

    const checkedExams = useSelector<RootState>(state => state.comparaison.checkedExams) as Ttraining[]
    const categories = useSelector<RootState>(state => state.comparaison.categories) as TgroupKeyParam[]
    const allCategories = useSelector<RootState>(state => state.comparaison.allCategories) as TkeyParamLayout[]
    const filters = useSelector<RootState>(state => state.comparaison.filters) as TComparaisonFilters
    const launchComparaison = useSelector<RootState>(state => state.comparaison.launchComparaison) as boolean
    const data = useSelector<RootState>(state => state.comparaison.data) as TtrainingKeyParameter

    const options = useSelector<RootState>(state => state.comparaison.options) as string
    const { auth, getKeyParamsLayout, layoutKeys, isAdmin } = useAuth()
    const { compare, downloadComparaisonPdf, downloadAdvancedComparaisonPdf } = useExam(false, auth?.['@id'])
    const [dateValue, setDateValue] = useState<dayjs.Dayjs | null>(null)
    const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
    const [open, setOpen] = React.useState(false);

    const [customLayouts, setCustomLayouts] = useState<TKeyParamLayout[]>([])

    const [selectedExams, setSelectedExams] = useState<string[]>([])

    const [selectedPdfOptionIndex, setSelectedPdfOptionIndex] = React.useState(0);


    const { download, isDownloading } = UseFileDownload()
    const { track } = useUserActivityLog()


    const comparaisonOptions = [
        {
            key: 'DOWNLOAD_PDF',
            title: t('report:buttonText'),
            enabled: true,
        },
        {
            key: 'DOWNLOAD_ADVANCED_PDF',
            title: t('report:buttonTextAdvanced'),
            enabled: true,
        },
    ]


    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        toggleOpen();
    };

    const toggleOpen = () => {
        setOpen(!open);
    };

    const id = open ? 'simple-popover' : undefined;

    useEffect(() => {
        getKeyParamsLayout.mutateAsync()
    }, [])

    useEffect(() => {
        if (!launchComparaison || isEmpty(checkedExams)) return

        compareTrainings()
        dispatch(runComparaison(false))

    }, [launchComparaison, checkedExams])

    useEffect(() => {
        setCustomLayouts(layoutKeys)
    }, [layoutKeys])

    useEffect(() => {
        if (isEmpty(customLayouts)) return
        compareTrainings(false, null)
    }, [customLayouts])

    const isFiltersEmpty = React.useMemo(() => {
        if (!filters) return true
        return isEmpty(filters.selectedTracks) && isEmpty(filters.selectedTrainingTypes) && !filters.startDate && !filters.endDate
    }, [filters])

    const formattedFilters = useMemo(() => {
        return transformFiltersToArray(filters)
    }, [filters])


    const openTrainingsModal = () => {
        dispatch(openModal(true))
    }

    const handleDelete = (exam: Ttraining) => {
        dispatch(updateCheckExam({ checked: false, exam }))
        removeData(exam)

    }
    const removeData = (exam: Ttraining) => {
        if (data) {
            let newData = [...data.items]
            newData = newData.filter(e => e.training.id !== exam?.id)
            dispatch(setDataItems(newData))
        }
    }

    const getUrlStrfromIDS = (ids: number[]) => {
        let str: string[] = []
        ids.forEach(id => {
            str.push(`${encodeURIComponent('training[]')}=${encodeURIComponent(id)}`)
        })

        return str.join('&')
    }

    const addTrainingFromResponse = (data: TtrainingKeyParameter) => {
        if (data) {
            dispatch(resetCheckedExam())
            dispatch(setData(data))
            if (!isEmpty(data?.items)) {
                data.items.forEach(({ training: exam }) => {
                    dispatch(updateCheckExam({ checked: true, exam }))

                })
            }
        }
    }

    const compareTrainings = (useIds: boolean = true, customDate?: dayjs.Dayjs | null) => {
        let ids = checkedExams.map(e => e.id)

        let selectedDate = customDate ? customDate : isNull(customDate) ? null : dateValue

        let date = useIds ? undefined
            : selectedDate ? dayjs(selectedDate).utc(true).format('YYYY-MM-DD') : undefined

        compare.mutateAsync({ ids: useIds ? getUrlStrfromIDS(ids) : '', date, options, allKeyParam: true, exclueIncompleteTrainings: true })
            .then(({ data }) => {
                dispatch(setAllKeyLayouts(getAllLayoutKeysFromData(data) ?? []))
                dispatch(setCategories(groupKeyParamsByCategories(customLayouts)))
                dispatch(setData(data))
                if (!useIds) {
                    addTrainingFromResponse(data)
                }
            }).catch(err => {
                console.log({ err });
                toast(t('error:generic'), { type: "error" })
            })

    }

    const resetAll = () => {
        dispatch(resetAllParams())
        dispatch(resetFilters())

    }

    const onReset = () => {
        dispatch(resetFilters())
    }

    const onSelectExam = (exam: string, checked: boolean) => {

        let exams = toggleItemInArray(selectedExams, exam)

        setSelectedExams(exams)


    }


    const downloadPdf = () => {

        const examIds = data.items.map(exam => encodeURIComponent(exam.training['@id']))

        const insightParamsIds = categories.map(param => encodeURIComponent(param.id ?? ""))


        downloadComparaisonPdf.mutateAsync({ examIds: examIds.join(','), insightParams: insightParamsIds.join(',') })
            .then(result => {

                download(result.data.url, result.data.filename)

            }).catch(err => {
                toast(t('error:generic'), { type: 'error' })


            }).finally(() => {
                track('COMPARISON_PDF_BUTTON_CLICKED')
            })

    }

    const downloadAdvPdf = () => {

        const examIds = data.items.map(exam => `${encodeURIComponent('training[]')}=${exam.training.id}`).join('&')


        downloadAdvancedComparaisonPdf.mutateAsync({ examIds, userId: auth['@id'] })
            .then(result => {

                download(result.data.url, result.data.filename)

            }).catch(err => {
                toast(t('error:generic'), { type: 'error' })


            }).finally(() => {
                track('ADVANCED_COMPARISON_PDF_BUTTON_CLICKED')
            })

    }

    const handleOptionPdfClick = (idx?: number) => {
        const index = isUndefined(idx) ? selectedPdfOptionIndex : idx
        const key = comparaisonOptions[index].key
        return key
    }

    const handlePdfBtnClick = (key: string) => {
        switch (key) {
            case 'DOWNLOAD_PDF':
                downloadPdf()
                break;
            case 'DOWNLOAD_ADVANCED_PDF':
                downloadAdvPdf()
                break;
            default:
                break;
        }
    }


    return (
        <Page withNameApp title={'navbar:comparison'}>
            <Header text='navbar:comparison'>
                <Box gap={1} display={'flex'} flexWrap={'wrap'}>
                    <Button onClick={resetAll} variant='outlined'
                        startIcon={<Icon icon='si:clear-all-fill'></Icon>}>{t('equimetre.reset.button')}</Button>
                    <Badge color='info' invisible={isFiltersEmpty} variant='dot'>
                        <LoadingButton aria-describedby={id} loading={compare.isLoading} onClick={handleClick}
                            variant='outlined'>{t('compareTodayTrainings')}</LoadingButton>
                    </Badge>
                    {/* Calndar popover */}
                    <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={(_, reason) => {

                            toggleOpen()

                        }}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        disableAutoFocus
                        disableEnforceFocus
                        disablePortal
                    >
                        <div onClick={e => e.stopPropagation()}>
                            {
                                !isFiltersEmpty && <>
                                    <Box p={2} flexDirection={'column'}>
                                        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                            <Typography variant='h6'>{t('eap:table:filters:filters')}</Typography>
                                            <Button disabled={isFiltersEmpty}
                                                startIcon={<Icon icon={'ic:baseline-clear-all'}></Icon>}
                                                onClick={onReset}>{t('equimetre.reset.button')}</Button>

                                        </Box>
                                        <ComparaisonFilters filters={formattedFilters}></ComparaisonFilters>
                                    </Box>
                                    <Divider></Divider>
                                </>
                            }

                            <Box display={'flex'} justifyContent={'end'} p={2}>
                                <Button onClick={() => {
                                    setDateValue(null)
                                    compareTrainings(false, null)
                                    toggleOpen()
                                }} variant='outlined'>{t('daterangepicker:today')}</Button>
                            </Box>
                            <StaticDatePicker
                                onAccept={value => {
                                    setDateValue(value)
                                    compareTrainings(false, value)
                                }}

                                value={dateValue}
                                onChange={(value) => setDateValue(value)}
                                onClose={() => toggleOpen()}
                            />
                        </div>
                    </Popover>
                    <SplitButton
                        disabled={downloadComparaisonPdf.isLoading || isDownloading || downloadAdvancedComparaisonPdf.isLoading || compare.isLoading}
                        options={comparaisonOptions}
                        selectedIndex={selectedPdfOptionIndex}
                        onIndexChange={(index) => {
                            setSelectedPdfOptionIndex(index)
                            handlePdfBtnClick(handleOptionPdfClick(index))

                        }} onClick={handlePdfBtnClick} />

                    <Button onClick={openTrainingsModal} variant='contained'>{t('compare:addTraining')}</Button>
                </Box>
            </Header>
            <Box display={'flex'} justifyContent={'end'} flexWrap={'wrap'} mt={1} gap={1}>

            </Box>
            <ComparaisonChips handleDelete={handleDelete} checkedExams={checkedExams} />

            <Divider sx={{ my: 2 }}></Divider>
            <ComparaisonSection
                onSelectExam={onSelectExam}
                compare={() => compareTrainings()}
                data={data}
                categories={categories}
                selectedExams={selectedExams}
                loading={compare.isLoading || getKeyParamsLayout.isLoading}></ComparaisonSection>

        </Page>
    )
}

export default Comparaison